import { render, staticRenderFns } from "./splitTab.vue?vue&type=template&id=66ffd60b&scoped=true"
import script from "./splitTab.vue?vue&type=script&lang=js"
export * from "./splitTab.vue?vue&type=script&lang=js"
import style0 from "./splitTab.vue?vue&type=style&index=0&id=66ffd60b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffd60b",
  null
  
)

export default component.exports